jQuery(document).ajaxComplete(function(event, xhr, settings) {
  setTimeout(function(){
         jQuery('#standard-shipping-option-div').on('click',function(){
        jQuery('.sherpa-container').show();
     });
    
    jQuery('.cart__checkout-button').removeClass('disabled');
    jQuery('.cart__checkout-button').removeAttr('disabled');
 
  },500);  
});

jQuery(document).ready(function($){
 
  setTimeout(function () {
    
    $(".pickup-availability-info > .caption-large").html('Pick Up and Delivery At <span class="color-foreground">Dulwich Hill Store</span>');
  }, 800); // 1000 milliseconds = 1 second
  
  $("#Details-HeaderMenu-3").contents().unwrap();
  $("header-menu").contents().unwrap();

  // Event listener for the "Edit Address" button
  $('.edit-address-btn').click(function() {
    // Get the address ID from the button's data attribute
    var addressId = $(this).data('address-id');

    // Toggle the display of the corresponding form
    var editForm = $('#EditAddress_' + addressId);
    var isExpanded = $(this).attr('aria-expanded') === 'true'; // Check current state

    if (isExpanded) {
      // If the form is already expanded, hide it
      editForm.slideUp();
      $(this).attr('aria-expanded', 'false');
    } else {
      // If the form is hidden, show it
      editForm.slideDown();
      $(this).attr('aria-expanded', 'true');
    }
  });

// jQuery('.edit-add').hide();
//  jQuery('.edit-address-btn').on('click', function() {
// jQuery('.edit-add').toggle();  
//   });
  jQuery('#AddAddress').hide();
 jQuery('#add-new-btn').on('click', function() {
jQuery('#AddAddress').toggle();  
  });

  // jQuery('#HeaderMenu-products').each(function() {
  //   // Add a link to the PRODUCTS menu that leads to the collection page
  //   var collectionUrl = '/collections';  // You can change this URL to any specific collection
  //   var linkHTML = '<a href="' + collectionUrl + '" class="header__menu-link">PRODUCTS</a>';
    
  //   // Prepend the link to the summary
  // jQuery(this).find('span').replaceWith(linkHTML);  // Replaces the span with the link
  // });
  
  if (jQuery('body').hasClass('template-article')) {
  jQuery('#HeaderMenu-recipes span').addClass('header__active-menu-item');
  }
  if (jQuery('body').hasClass('template-product')) {
  jQuery('#HeaderMenu-shop-online span').addClass('header__active-menu-item');
  }
  // Wrap the <ul> with a <div> element
  $('#HeaderMenu-MenuList-3').wrap('<div class="submneu-menu-wrapper"></div>');
  // alert('abc');
  jQuery(".slide-test").addClass('abc');
  

    // Get the width of each carousel item dynamically
   

jQuery(".slide-test").owlCarousel({
    loop: true,                 // Loop through slides
    margin: 10,   
    dots: true,                 // Enable dots for navigation
    nav: true,                  // Enable next/prev buttons
    autoplay: true,             // Enable autoplay
    autoplayTimeout: 5000,      // Auto play interval (5000ms = 5 seconds)
    autoplayHoverPause: true,   // Pause autoplay on hover
    smartSpeed: 800,            // Set the speed of the transition (in milliseconds)
    items: 4,                   // Number of items visible
    responsive: {               // Responsive breakpoints
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        1000: {
            items: 4
        }
    }
});


  
  jQuery('.test').insertAfter('.article-template__content');

  jQuery('.footer-sec').eq(0).addClass('footer-logo-wrap');
    // $(".product-single__photo:not(:first)").hide();
    jQuery('.footer-sec').eq(1).addClass('footer-main-sec');
  jQuery('.footer-sec').eq(2).addClass('footer-quick-sec');
    jQuery('.footer-sec').eq(3).addClass('footercnt-sec');
 jQuery(".reviews-slider").owlCarousel({
    loop: true,                 // Loop through slides
    margin: 10,   
    dots: true,                 // Enable dots for navigation
    nav: true,                  // Enable next/prev buttons
    autoplay: true,             // Enable autoplay
    autoplayTimeout: 5000,      // Auto play interval (5000ms = 5 seconds)
    autoplayHoverPause: true,   // Pause autoplay on hover
    smartSpeed: 800,            // Set the speed of the transition (in milliseconds)
    items: 1,                   // Number of items visible
    responsive: {               // Responsive breakpoints
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        1000: {
            items: 1
        }
    }
});


        $(".product__description").show();
        $(".toggle-icon").text("-");

        // When the entire description strip is clicked, toggle visibility
        $(".product-desc-wrap").click(function(event) {
            // If the click is not on the toggle button itself, toggle the description
            var description = $(this).find(".product__description");
            description.slideToggle(); // Toggle visibility

            // Toggle the icon and text (plus to minus)
            var icon = $(this).find(".toggle-icon");
            if (icon.text() === "+") {
                icon.text("-");
            } else {
                icon.text("+");
            }

            // Prevent the click from triggering the toggle when clicking on the button itself
            if ($(event.target).closest('.toggle-description').length) {
                return;
            }
        });
  



  jQuery(".blog-post-wrap").owlCarousel({
        loop: true,                // Loop through slides
        margin: 25,   
        nav: true,                 // Enable next/prev buttons
        // autoplay: true,            // Enable auto play
        // autoplayTimeout: 3000,     // Auto play interval
        items: 4,                  // Number of items visible
        responsive: {              // Responsive breakpoints
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            1000: {
                items: 4
            }
        }
    });



   jQuery(window).scroll(function() {
        var sticky = jQuery('body');
        var scroll = jQuery(window).scrollTop();
        if (scroll >= 100) sticky.addClass('sticky_header');
        else sticky.removeClass('sticky_header');
    });

  if ($('body').hasClass('template-article')) {
    $('.site-footer__list-item a').eq(3).addClass('active');
  }
  var currentUrl = window.location.pathname;
  $('.site-footer__list-item a').each(function() {
    var linkHref = $(this).attr('href');
    if (linkHref === currentUrl || (currentUrl.includes(linkHref) && linkHref !== '/')) {
      $(this).addClass('active');
    }
  });
  $('.login-btn').on('click', function(e) {
    $('.error_msg').remove();  // Remove previous error messages

    var email = $('#CustomerEmail').val();
    var password = $('#CustomerPassword').val();  // Add password variable

    // Email validation
    if (email === '') {
        e.preventDefault();  // Prevent form submission
        $('#CustomerEmail').addClass('error');  // Add error class to input field
        $('<span class="error_msg">This field is required.</span>').insertAfter('#CustomerEmail');  // Display error message
    } else {
        if (validateEmail(email)) {
            $('#CustomerEmail').removeClass('error');  // Remove error class if email is valid
        } else {
            e.preventDefault();  // Prevent form submission
            $('#CustomerEmail').addClass('error');  // Add error class to input field
            $('<span class="error_msg">Please enter a valid email address.</span>').insertAfter('#CustomerEmail');  // Display error message
        }
    }

    // Password validation
    if (password === '') {
        e.preventDefault();  // Prevent form submission
        $('#CustomerPassword').addClass('error');  // Add error class to input field
        $('<span class="error_msg">This field is required.</span>').insertAfter('#CustomerPassword');  // Display error message near the password field
    } else {
        // Check if password contains at least one digit and one special character
        // if (!validatePassword(password)) {
        //     e.preventDefault();  // Prevent form submission
        //     $('#CustomerPassword').addClass('error');  // Add error class to input field
        //     $('<span class="error_msg">Password must contain at least one digit and one special character.</span>').insertAfter('#CustomerPassword');  // Display error message
        // } else {
            $('#CustomerPassword').removeClass('error');  // Remove error class if password is valid
        // }
    }
});

function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

function validatePassword(password) {
    // Password must contain at least one digit and one special character
    var re = /^(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;"'<>,.?/\\|`~])[A-Za-z\d!@#$%^&*()_+{}\[\]:;"'<>,.?/\\|`~]{6,}$/;
    return re.test(password);
}
  $('.reg-btn').on('click', function(e) {
    // Remove previous error messages
    $('.error_msg').remove();
    
    // Get form values
    var firstName = $('#RegisterForm-FirstName').val();
    var lastName = $('#RegisterForm-LastName').val();
    var email = $('#RegisterForm-email').val();
    var password = $('#RegisterForm-password').val();
    var formValid = true;  // Track if form is valid

    // First name validation
    if (firstName === '') {
        e.preventDefault();
        $('#RegisterForm-FirstName').addClass('error');
        $('<span class="error_msg">This field is required.</span>').insertAfter('#RegisterForm-FirstName');
        formValid = false;
    } else {
        $('#RegisterForm-FirstName').removeClass('error');
    }

    // Last name validation
    if (lastName === '') {
        e.preventDefault();
        $('#RegisterForm-LastName').addClass('error');
        $('<span class="error_msg">This field is required.</span>').insertAfter('#RegisterForm-LastName');
        formValid = false;
    } else {
        $('#RegisterForm-LastName').removeClass('error');
    }

    // Email validation
    if (email === '') {
        e.preventDefault();
        $('#RegisterForm-email').addClass('error');
        $('<span class="error_msg">This field is required.</span>').insertAfter('#RegisterForm-email');
        formValid = false;
    } else if (!validateEmail(email)) {
        e.preventDefault();
        $('#RegisterForm-email').addClass('error');
        $('<span class="error_msg">Please enter a valid email address.</span>').insertAfter('#RegisterForm-email');
        formValid = false;
    } else {
        $('#RegisterForm-email').removeClass('error');
    }

    // Password validation
    if (password === '') {
        e.preventDefault();
        $('#RegisterForm-password').addClass('error');
        $('<span class="error_msg">This field is required.</span>').insertAfter('#RegisterForm-password');
        formValid = false;
    } else if (password.length < 6) {
        e.preventDefault();
        $('#RegisterForm-password').addClass('error');
        $('<span class="error_msg">Password must be at least 6 characters long.</span>').insertAfter('#RegisterForm-password');
        formValid = false;
    } else if (!validatePassword(password)) {
        e.preventDefault();
        $('#RegisterForm-password').addClass('error');
        $('<span class="error_msg">Password must contain at least one digit and one special character.</span>').insertAfter('#RegisterForm-password');
        formValid = false;
    } else {
        $('#RegisterForm-password').removeClass('error');
    }

   

    // Prevent form submission if validation fails
    if (!formValid) {
        e.preventDefault();
    }
});

function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

function validatePassword(password) {
    // Password must contain at least one digit, one special character, and one letter
    var re = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;"'<>,.?/\\|`~])[A-Za-z\d!@#$%^&*()_+{}\[\]:;"'<>,.?/\\|`~]{6,}$/;
    return re.test(password);
}
  
    $('.recover-btn').on('click', function(e) {
    $('.error_msg').remove();  // Remove previous error messages

    var email = $('#RecoverEmail').val();

    // Email validation
    if (email === '') {
        e.preventDefault();  // Prevent form submission
        $('#RecoverEmail').addClass('error');  // Add error class to input field
        $('<span class="error_msg">This field is required.</span>').insertAfter('#RecoverEmail');  // Display error message
    } else {
        if (validateEmail(email)) {
            $('#RecoverEmail').removeClass('error');  // Remove error class if email is valid
        } else {
            e.preventDefault();  // Prevent form submission
            $('#RecoverEmail').addClass('error');  // Add error class to input field
            $('<span class="error_msg">Please enter a valid email address.</span>').insertAfter('#RecoverEmail');  // Display error message
        }
    }

    // Password validation
  
});

function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

     // When the form is submitted
    $('.resetbtn-class').on('click', function(e) {
      // Remove previous error messages
      $('.error_msg').remove();

      // Get form values
      var password = $('#password').val();
      var confirmPassword = $('#password_confirmation').val();
      var formValid = true;

      // Password validation
      if (password === '') {
        e.preventDefault();
        $('#password').addClass('error');
        $('<span class="error_msg">This field is required.</span>').insertAfter('#password');
        formValid = false;
      } else if (password.length < 6) {
        e.preventDefault();
        $('#password').addClass('error');
        $('<span class="error_msg">Password must be at least 6 characters long.</span>').insertAfter('#password');
        formValid = false;
      } else if (!/^(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;"'<>,.?/\\|`~])[A-Za-z\d!@#$%^&*()_+{}\[\]:;"'<>,.?/\\|`~]{6,}$/.test(password)) {
        e.preventDefault();
        $('#password').addClass('error');
        $('<span class="error_msg">Password must contain at least one digit and one special character.</span>').insertAfter('#password');
        formValid = false;
      }

      // Confirm password validation
      if (confirmPassword === '') {
        e.preventDefault();
        $('#password_confirmation').addClass('error');
        $('<span class="error_msg">This field is required.</span>').insertAfter('#password_confirmation');
        formValid = false;
      } else if (password !== confirmPassword) {
        e.preventDefault();
        $('#password_confirmation').addClass('error');
        $('<span class="error_msg">Passwords do not match.</span>').insertAfter('#password_confirmation');
        formValid = false;
      }

      // Prevent form submission if validation fails
      if (!formValid) {
        e.preventDefault();
      }
    });
  jQuery('input, select, textarea').focus(function() {
    // Add "input-focus" class to the parent div
    jQuery(this).closest('.field').addClass('input-focus');
    
    // Add "focus" class to the input itself
    jQuery(this).addClass('focus');
});

jQuery('input, select, textarea').blur(function() {
    // Remove "input-focus" class from the parent div
    jQuery(this).closest('.field').removeClass('input-focus');
    
    // Remove "focus" class from the input itself
    jQuery(this).removeClass('focus');
});

// Add "value-focus" class when typing starts (input event)
jQuery('input, select, textarea').on('input', function() {
    var $inputWrapper = jQuery(this).closest('.field'); // Select the parent wrapper

    // Add "value-focus" class to the wrapper if input has value
    if (jQuery(this).val().length > 0) {
        $inputWrapper.addClass('value-focus');
    } else {
        $inputWrapper.removeClass('value-focus');
    }
});
    //   jQuery("#ContactForm").on("submit", function (event) {
    //     event.preventDefault();
        
    //     // Clear previous error and success messages
    //     $('.error').remove();
    //     $('.success-message').remove();

    //     let isValid = true;

    //     // Validate Name field
    //     if ($('#ContactForm-name').val().trim() === '') {
    //       $('<span class="error">This field is required.</span>').insertAfter('#ContactForm-name');
    //       isValid = false;
    //     }

    //     // Validate Phone field
    //     if ($('#ContactForm-phone').val().trim() === '') {
    //       $('<span class="error">This field is required.</span>').insertAfter('#ContactForm-phone');
    //       isValid = false;
    //     }

    //     // Validate Email field
    //     if ($('#ContactForm-email').val().trim() === '') {
    //       $('<span class="error">This field is required.</span>').insertAfter('#ContactForm-email');
    //       isValid = false;
    //     }
        
    //     // Validate additional Body field (if present)
    //     if ($('#ContactForm-body').length && $('#ContactForm-body').val().trim() === '') {
    //       $('<span class="error">This field is required.</span>').insertAfter('#ContactForm-body');
    //       isValid = false;
    //     }

    //     // If the form is valid, show the success message
    //     if (!isValid) {
    //         // Show general error message
    //         $('<span class="error">One or more fields are required.</span>').insertAfter('form');
    //     }
    // });

 $('.cnt-btn').on('click', function(e) {
    // Remove previous error messages
    $('.error_msg').remove();
    
    // Get form values
    var firstName = $('#ContactForm-name').val();  // Corrected to use #ContactForm-name
    var phone = $('#ContactForm-phone').val(); // Corrected to use #ContactForm-lastname
    var email = $('#ContactForm-email').val();
    var message = $('#ContactForm-body').val();
    var formValid = true;  // Track if form is valid

    // First name validation
    if (firstName === '') {
        e.preventDefault();
        $('#ContactForm-name').addClass('error');
        $('<span class="error_msg">This field is required.</span>').insertAfter('#ContactForm-name');
        formValid = false;
    } else {
        $('#ContactForm-name').removeClass('error');
    }

    // Last name validation
    if (phone === '') {
        e.preventDefault();
        $('#ContactForm-phone').addClass('error'); // Corrected selector for last name
        $('<span class="error_msg">This field is required.</span>').insertAfter('#ContactForm-phone');
        formValid = false;
    } else {
        $('#ContactForm-phone').removeClass('error');
    }

    // Email validation
    if (email === '') {
        e.preventDefault();
        $('#ContactForm-email').addClass('error');
        $('<span class="error_msg">This field is required.</span>').insertAfter('#ContactForm-email');
        formValid = false;
    } else if (!validateEmail(email)) {
        e.preventDefault();
        $('#ContactForm-email').addClass('error');
        $('<span class="error_msg">Please enter a valid email address.</span>').insertAfter('#ContactForm-email');
        formValid = false;
    } else {
        $('#ContactForm-email').removeClass('error');
    }

    // Password validation (if applicable)
    if (message === '') {
        e.preventDefault();
        $('#ContactForm-body').addClass('error');
        $('<span class="error_msg">This field is required.</span>').insertAfter('#ContactForm-body');
        formValid = false;
    } else {
        $('#ContactForm-body').removeClass('error');
    }

    // Prevent form submission if validation fails
    if (!formValid) {
        e.preventDefault();
    }
});

function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}


// Function to toggle password visibility for multiple password fields using specific IDs
$('#show-password-icon1').on('click', function() {
    var passwordField = $('#RegisterForm-password');
    var passwordFieldType = passwordField.attr('type');

    // Toggle password visibility
    if (passwordFieldType === 'password') {
        passwordField.attr('type', 'text'); // Show password
        $(this).removeClass('fa-eye').addClass('fa-eye-slash'); // Change icon to eye-slash
    } else {
        passwordField.attr('type', 'password'); // Hide password
        $(this).removeClass('fa-eye-slash').addClass('fa-eye'); // Change icon back to eye
    }
});

$('#show-password-icon2').on('click', function() {
    var passwordField = $('#CustomerPassword');
    var passwordFieldType = passwordField.attr('type');

    // Toggle password visibility
    if (passwordFieldType === 'password') {
        passwordField.attr('type', 'text'); // Show password
        $(this).removeClass('fa-eye').addClass('fa-eye-slash'); // Change icon to eye-slash
    } else {
        passwordField.attr('type', 'password'); // Hide password
        $(this).removeClass('fa-eye-slash').addClass('fa-eye'); // Change icon back to eye
    }
});

$('#show-password-icon3').on('click', function() {
    var passwordField = $('#password');
    var passwordFieldType = passwordField.attr('type');

    // Toggle password visibility
    if (passwordFieldType === 'password') {
        passwordField.attr('type', 'text'); // Show password
        $(this).removeClass('fa-eye').addClass('fa-eye-slash'); // Change icon to eye-slash
    } else {
        passwordField.attr('type', 'password'); // Hide password
        $(this).removeClass('fa-eye-slash').addClass('fa-eye'); // Change icon back to eye
    }
});

$('#show-password-icon4').on('click', function() {
    var passwordField = $('#password_confirmation');
    var passwordFieldType = passwordField.attr('type');

    // Toggle password visibility
    if (passwordFieldType === 'password') {
        passwordField.attr('type', 'text'); // Show password
        $(this).removeClass('fa-eye').addClass('fa-eye-slash'); // Change icon to eye-slash
    } else {
        passwordField.attr('type', 'password'); // Hide password
        $(this).removeClass('fa-eye-slash').addClass('fa-eye'); // Change icon back to eye
    }
});
    // Check if the current URL contains '/collection'
    if (window.location.pathname.indexOf('/collection') !== -1) {
        // Add the 'login-page' class to the <body> tag
        $('body').addClass('login-page');
    }
  if (window.location.pathname.indexOf('/account/addresses') !== -1) {
        // Add the 'login-page' class to the <body> tag
        $('body').addClass('login-page');
    }
    if (window.location.pathname.indexOf('/account/orders/') !== -1) {
        // Add the 'login-page' class to the <body> tag
        $('body').addClass('login-page');
    }
   if (window.location.pathname.indexOf('/products') !== -1) {
        // Add the 'login-page' class to the <body> tag
        $('body').addClass('login-page');
    }
  if (window.location.pathname.indexOf('/pages/our-story') !== -1) {
        // Add the 'login-page' class to the <body> tag
        $('body').addClass('login-page');
    }
   if (window.location.pathname.indexOf('/challenge') !== -1) {
        // Add the 'login-page' class to the <body> tag
        $('body').addClass('login-page');
    }
  

});
$(document).ready(function() {
  
  $('.product-variants .weight-tab').click(function() {
   
    var selectedVariant = $(this);
    var selectedPrice = selectedVariant.data('price');
    var selectedVariantId = selectedVariant.data('variant-id');
    console.log(selectedVariantId);
    $('#product-price').text(selectedPrice);

    $('.add-to-cart-btn').data('variant-id', selectedVariantId);

     if ($(this).hasClass('active')) {
    // If already active, remove it (toggle off)
    $(this).removeClass('active-variant');
    } else {
      // Remove from siblings
     $(this).parent().find('.weight-tab').removeClass('active-variant');
      
      // Add to clicked button
      $(this).addClass('active-variant');
    }
    $('.add-to-cart-btn').prop('disabled', false); 
  });
 var count = 0;
    jQuery('.product-variants .weight-tab').each(function(index) {
       var a =  jQuery(this).attr('data-variant-id');
        console.log(a);
        count ++;
    });
  $('.add-to-cart-btn').click(function(e) {
    jQuery('.cart-msg').remove();
   
      // e.preventDefault();  
       console.log(count);
    var variantId = jQuery('.product-variant-id').val();
    
    // if (!variantId) {
    //   alert('Please select a variant before adding to the cart.');
    //   return;
    // }
    $.ajax({
      url: '/cart/add.js',   
      type: 'POST',
      data: {
        id: variantId,        
        quantity: 1  
      },
      dataType: 'json',
      success: function(cart) {
        console.log('Item added to cart:', cart);
        jQuery('<span class="cart-msg">Item added to cart</span>').insertAfter('.add-to-cart-btn');
       // $('#cart-popup').fadeIn();
       // $('html').addClass('popup-open');

        // setTimeout(function() {
        //   $('#cart-popup').fadeOut();
        //   $('html').removeClass('popup-open');
        // }, 5000); 
      },
      error: function(error) {
        console.error('Error adding item to cart:', error.responseText); // Log any errors
      }
    });
 
  });
$('.weight-tab ').click(function () {
   $('html, body').stop(); // This stops the scroll animation
});
  $('#close-popup').on('click', function() {
    $('#cart-popup').fadeOut();
    $('html').removeClass('popup-open');
  });

});
